import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AngularFireAuth } from '@angular/fire/auth';
import { Users } from 'my-lib-sanfelici';
import { UsersService } from 'my-lib-sanfelici';






@Component({
  selector: 'app-cataloghi',
  templateUrl: './cataloghi.component.html',
  styleUrls: ['./cataloghi.component.css']
})
export class CataloghiComponent implements OnInit {
  user: Observable<Users>;
  constructor(
    public afAuth: AngularFireAuth,
    public usersservice: UsersService
  ) { }

  ngOnInit() {
    this.user = this.usersservice.users;
  }

}
